import {
  ProhibitedRegular,
  BorderNoneRegular,
  ArrowShuffleRegular,
  ArrowSwapRegular,
  ColorFillRegular,
  SearchRegular,
} from "@fluentui/react-icons";
import styles from "./ColourToolsPanel.module.css";

interface QuickActionsSectionProps {
  readonly busy: boolean;
  readonly hasTheme: boolean;
  readonly onClearFill: () => void;
  readonly onClearLine: () => void;
  readonly onShuffle: () => void;
  readonly onOpenReplace: () => void;
  readonly onOnBrandFill: () => void;
  readonly onOpenNonBrand: () => void;
}

/** Quick Actions + Find & Fix action grids — extracted from ColourToolsPanel
 * so it stays focused on composition/layout; this owns no state of its own. */
export function QuickActionsSection({
  busy,
  hasTheme,
  onClearFill,
  onClearLine,
  onShuffle,
  onOpenReplace,
  onOnBrandFill,
  onOpenNonBrand,
}: Readonly<QuickActionsSectionProps>) {
  return (
    <>
      <div className={styles.actionSection}>
        <span className={styles.groupLabel}>Quick Actions</span>
        <div className={styles.actionGrid}>
          <button
            type="button"
            className={styles.actionBtn}
            data-cmd-action="color-no-fill"
            onClick={onClearFill}
            disabled={busy}
            title="Remove fill from selection"
            data-testid="qa-no-fill"
          >
            <ProhibitedRegular className={styles.actionBtnIcon} />
            No Fill
          </button>
          <button
            type="button"
            className={styles.actionBtn}
            data-cmd-action="color-no-line"
            onClick={onClearLine}
            disabled={busy}
            title="Remove line/border from selection"
            data-testid="qa-no-line"
          >
            <BorderNoneRegular className={styles.actionBtnIcon} />
            No Line
          </button>
          <button
            type="button"
            className={styles.actionBtn}
            data-cmd-action="color-shuffle"
            onClick={onShuffle}
            disabled={busy || !hasTheme}
            title="Shuffle theme colour on selection"
            data-testid="qa-shuffle"
          >
            <ArrowShuffleRegular className={styles.actionBtnIcon} />
            Shuffle
          </button>
        </div>
      </div>

      <div className={styles.actionSection}>
        <span className={styles.groupLabel}>Find &amp; Fix</span>
        <div className={styles.actionGrid}>
          <button
            type="button"
            className={styles.actionBtn}
            data-cmd-action="color-replace"
            onClick={onOpenReplace}
            disabled={busy}
            title="Open Replace Colors dialog"
            data-testid="qa-open-replace"
          >
            <ArrowSwapRegular className={styles.actionBtnIcon} />
            Replace
          </button>
          <button
            type="button"
            className={styles.actionBtn}
            data-cmd-action="color-on-brand"
            onClick={onOnBrandFill}
            disabled={busy || !hasTheme}
            title="Apply nearest on-brand fill to selection"
            data-testid="qa-on-brand-fill"
          >
            <ColorFillRegular className={styles.actionBtnIcon} />
            On-Brand Fill
          </button>
          <button
            type="button"
            className={styles.actionBtn}
            data-cmd-action="color-show-non-brand"
            onClick={onOpenNonBrand}
            disabled={busy}
            title="Detect and fix non-brand colors"
            data-testid="qa-open-non-brand"
          >
            <SearchRegular className={styles.actionBtnIcon} />
            Show Non-Brand
          </button>
        </div>
      </div>
    </>
  );
}
